import { render, staticRenderFns } from "./DateTimeParameterValue.vue?vue&type=template&id=18f4d3a8&"
import script from "./DateTimeParameterValue.vue?vue&type=script&lang=ts&"
export * from "./DateTimeParameterValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports